import { render } from "./FileDropZone.vue?vue&type=template&id=5ff3c62f&scoped=true"
import script from "./FileDropZone.vue?vue&type=script&lang=js"
export * from "./FileDropZone.vue?vue&type=script&lang=js"

import "./FileDropZone.vue?vue&type=style&index=0&id=5ff3c62f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff3c62f"]])

export default __exports__